<p-card>
    <ng-template pTemplate="header">
        <div class="flex flex-column w-full p-3">
            <div class="flex justify-content-between align-items-center">
                <div class="flex align-items-center gap-3">
                    <img class="color-image" [style]="{'width': '40px'}" src="/assets/demo/images/logos/check-list.png">
                    <h2 class="font-bold m-0">
                        Solicitud de Registro de Profesionales:
                        {{profesionSeleccionada?.accion}} - Ámbito: {{procesoSeleccionado?.ambito}}
                    </h2>
                </div>
                <div>
                    <p-button label="Regresar" icon="pi pi-undo" class="p-button-rounded p-button-primary"
                        [routerLink]="['/users/registro-profesionales']" routerLinkActive="router-link-active"
                        pTooltip="Regresar">
                    </p-button>
                </div>
            </div>
            <hr />

            <div class="mt-3 p-4 border-1 border-round" style="border-color: #c7d0dd;">
                <div class="text-lg font-bold mb-3 text-color-secondary">
                    Detalles de la Solicitud
                </div>
                <div class="grid">
                    <div class="col-12 md:col-4">
                        <div class="flex align-items-center gap-3">
                            <i class="pi pi-briefcase text-3xl text-color-secondary"></i>
                            <div class="text-lg">
                                <strong>Profesión:</strong><br> {{titleCase(profesionSeleccionada?.descripcion)}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="flex align-items-center gap-3">
                            <i class="pi pi-cog text-3xl text-color-secondary"></i>
                            <div class="text-lg">
                                <strong>Modalidad:</strong><br> {{profesionSeleccionada?.accion}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-4">
                        <div class="flex align-items-center gap-3">
                            <i class="pi pi-building text-3xl text-color-secondary"></i>
                            <div class="text-lg">
                                <strong>Ambiente:</strong><br> {{procesoSeleccionado?.ambito}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>


    <ng-template pTemplate="content">
        <form [formGroup]="formRegistroProfesional">
            <p-accordion [activeIndex]="0" [selectOnFocus]="true" class="w-full" expandIcon="pi pi-plus"
                collapseIcon="pi pi-minus">
                <p-accordionTab>
                    <ng-template pTemplate="header">
                        <span class="flex align-items-center gap-2 w-full">
                            <span class="font-bold white-space-nowrap">
                                Información general <i class="pi pi-tag ml-auto mr-2"></i>
                            </span>
                        </span>
                    </ng-template>

                    <!-- Fila 1: Tipo de persona / Nacionalidad -->
                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="tipoPersona">Tipo de persona <small
                                        style="color:red"><b>*</b></small></label>
                                <p-dropdown id="tipoPersona" styleClass="w-full force-full-width" showError pAutoFocus
                                    [options]="tiposPersona" formControlName="tipoPersona" [required]="true"
                                    optionLabel="nombre" [showClear]="true" (onClear)="onClearTipoPersona($event)"
                                    (onChange)="onChangeTipoPersona($event)" placeholder="Tipo de Persona">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="tiposNacionalidad">Nacionalidad <small
                                        style="color:red"><b>*</b></small></label>

                                <p-dropdown id="tiposNacionalidad" formControlName="tiposNacionalidad"
                                    [options]="paises" optionLabel="alias2" optionValue="idCatalogo" [showClear]="true"
                                    placeholder="Seleccione una nacionalidad" styleClass="w-full">
                                </p-dropdown>


                            </div>
                        </div>
                    </div>

                    <!-- Fila 2: Tipo de usuario / Tipo de documento -->
                    <div class="form-row" *ngIf="!isNit()">

                        <div class="form-column">
                            <div class="field">
                                <label for="tipoDocumento">Tipo de documento <small
                                        style="color:red"><b>*</b></small></label>
                                <p-dropdown id="tipoDocumento" showError [options]="tiposDocumento"
                                    styleClass="w-full force-full-width" formControlName="tipoDocumento"
                                    [required]="true" optionLabel="nombre" [showClear]="true"
                                    (onChange)="onChangeTipoDocumento($event)" placeholder="Tipo de documento">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="numeroDocumento">Documento <small style="color:red"><b>*</b></small></label>
                                <p-inputMask id="numeroDocumento" formControlName="numeroDocumento"
                                    tooltipPosition="right" styleClass="w-full force-full-width"
                                    mask="{{formRegistroProfesional.get('tipoDocumento')?.value?.mascara}}"
                                    placeholder="{{formRegistroProfesional.get('tipoDocumento')?.value?.placeholder}}"
                                    required>
                                </p-inputMask>

                            </div>
                        </div>
                    </div>

                    <!-- Fila 3: Documento / Nombres o Razón Social -->

                    <div class="form-row">
                        <div class="form-column" *ngIf="isNit()" style="grid-column: span 2;">
                            <div class="field">
                                <label for="_razonSocial">Razón Social / Denominación</label>
                                <textarea id="_razonSocial" rows="3" pInputTextarea class="w-full force-full-width"
                                    placeholder="Razón Social / Denominación" formControlName="nombres">
        </textarea>
                            </div>
                        </div>

                        <!-- Si NO es NIT, mostrar nombres y apellidos en dos columnas -->
                        <ng-container *ngIf="!isNit()">
                            <div class="form-column" style="flex: 1;">
                                <div class="field">
                                    <label for="_nombres">
                                        Nombres <small style="color:red"><b>*</b></small>
                                    </label>
                                    <input id="_nombres" placeholder="Nombres" pInputText formControlName="nombres" />
                                </div>
                            </div>

                            <div class="form-column" style="flex: 1;">
                                <div class="field">
                                    <label for="_apellidos">
                                        Apellidos <small style="color:red"><b>*</b></small>
                                    </label>
                                    <input id="_apellidos" placeholder="Apellidos" pInputText
                                        formControlName="apellidos" />
                                </div>
                            </div>
                        </ng-container>
                    </div>




                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="correo">Correo Electrónico <small style="color:red"><b>*</b></small></label>
                                <input id="correo" formControlName="correo" placeholder="Correo" pInputText
                                    type="email" />
                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="telefonoUsuario">Teléfono <small style="color:red"><b>*</b></small></label>
                                <p-inputMask id="telefonoUsuario" mask="(999) 9999-9999" formControlName="celular"
                                    styleClass="w-full force-full-width" [required]="true" placeholder="####-####">
                                </p-inputMask>
                            </div>
                        </div>
                    </div>
                </p-accordionTab>


                <!-- <p-accordionTab>
                    <ng-template pTemplate="header">
                        <span class="flex align-items-center gap-2 w-full">
                            <span class="font-bold white-space-nowrap">
                                Modalidad de Registro <i class="pi pi-tag ml-auto mr-2"></i>
                            </span>
                        </span>
                    </ng-template>
                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="ambito">Ambito de Registro <small style="color:red"><b>*</b></small></label>

                                <p-dropdown formControlName="ambito" [options]="tipoAmbito"
                                    optionLabel="descripcionAmbito" optionValue="idAmbito" [showClear]="true"
                                    placeholder="Seleccione un ámbito" (onChange)="onChangeAmbito($event)"
                                    styleClass="w-full">
                                </p-dropdown>



                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="categoriaProfesion">Categoria de Profesión <small
                                        style="color:red"><b>*</b></small></label>
                                <p-dropdown id="categoriaProfesion" showError pAutoFocus
                                    styleClass="w-full force-full-width" [options]="categoriaConProfesiones"
                                    formControlName="categoriaProfesion" [required]="true" optionLabel="descripcion"
                                    optionValue="idClasificacion" [showClear]="true"
                                    (onChange)="onChangeCategoriaProfesion($event)"
                                    placeholder="Seleccione un categoria Profesion">
                                </p-dropdown>

                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="profesion">Profesión <small style="color:red"><b>*</b></small></label>
                                <p-dropdown id="profesion" showError pAutoFocus styleClass="w-full force-full-width"
                                    [options]="profesionesFiltradas" formControlName="profesion" [required]="true"
                                    optionLabel="descripcion" optionValue="idProfesion" [showClear]="true"
                                    placeholder="Seleccione una Profesion">
                                </p-dropdown>


                            </div>
                        </div>
                    </div>
                </p-accordionTab> -->

                <p-accordionTab>
                    <ng-template pTemplate="header">
                        <span class="flex align-items-center gap-2 w-full">
                            <span class="font-bold white-space-nowrap">
                                Formación Académica <i class="pi pi-tag ml-auto mr-2"></i>
                            </span>
                        </span>
                    </ng-template>
                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="nivelAcademico">Nivel Académico <small
                                        style="color:red"><b>*</b></small></label>


                                <p-dropdown id="nivelAcademico" showError [options]="nivelAcademicoFiltrado"
                                    optionValue="idCatalogo" styleClass="w-full force-full-width"
                                    formControlName="nivelAcademico" [required]="true" optionLabel="nombre"
                                    [showClear]="true" placeholder="Nivel Académico">
                                </p-dropdown>



                            </div>
                        </div>

                        <div class="form-column">
                            <div class="field">
                                <label for="titulo">Título Obtenido / Certificación <small
                                        style="color:red"><b>*</b></small></label>
                                <input id="titulo" placeholder="Título Obtenido" pInputText formControlName="titulo" />
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="centroEstudios">Centro de Estudios / Acreditación<small
                                        style="color:red"><b>*</b></small></label>
                                <input id="centroEstudios" placeholder="Centro de Estudios / Formación" pInputText
                                    formControlName="centroEstudios" />
                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="fechaGraduacion">Fecha de Graduación / Acreditación <small
                                        style="color:red"><b>*</b></small></label>

                                <p-calendar id="fechaGraduacion" formControlName="fechaGraduacion"
                                    styleClass="w-full force-full-width" [maxDate]="today"
                                    placeholder="Fecha de Graduacion / Acreditación" dateFormat="dd/mm/yy"
                                    showIcon="true" [showButtonBar]="true" [touchUI]="true" [showOnFocus]="true"
                                    inputStyleClass="w-full"></p-calendar>

                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="paisEstudios">País de Estudio / Acreditación <small
                                        style="color:red"><b>*</b></small></label>

                                <p-dropdown formControlName="paisEstudios" [options]="paises" optionLabel="nombre"
                                    optionValue="idCatalogo" [showClear]="true" placeholder="Seleccione un Pais"
                                    styleClass="w-full">
                                </p-dropdown>



                            </div>
                        </div>

                    </div>

                </p-accordionTab>





                <p-accordionTab *ngIf="this.procesoSeleccionado?.accion != 'Primera Vez'">
                    <ng-template pTemplate="header">
                        <span class="flex align-items-center gap-2 w-full">
                            <span class="font-bold white-space-nowrap">
                                Carnet Actual <i class="pi pi-tag ml-auto mr-2"></i>
                            </span>
                        </span>
                    </ng-template>
                    <div class="form-row">
                        <div class="form-column">
                            <div class="field">
                                <label for="numRegistro">Numero de Registro / Carnet Actual <small
                                        style="color:red"><b>*</b></small></label>
                                <input id="numRegistro" placeholder="Numero de Registro" pInputText
                                    formControlName="numRegistro" />
                            </div>
                        </div>
                        <div class="form-column">
                            <div class="field">
                                <label for="fechaVencimiento">Fecha de Vencimiento <small
                                        style="color:red"><b>*</b></small></label>
                                <p-calendar id="fechaVencimiento" formControlName="fechaVencimiento" [minDate]="minDate"
                                    styleClass="w-full force-full-width" placeholder="Fecha de Vencimiento"
                                    dateFormat="dd/mm/yy" showIcon="true" [showButtonBar]="true" [touchUI]="true"
                                    [showOnFocus]="true" inputStyleClass="w-full"></p-calendar>

                            </div>
                        </div>
                    </div>
                </p-accordionTab>

            </p-accordion>
        </form>
    </ng-template>


    <ng-template pTemplate="footer">
        <p-button label="Guardar Solicitud" icon="pi pi-save" class="p-button-rounded p-button-primary" [rounded]="true"
            [outlined]="false" pTooltip="Guardar Solicitud" severity="primary" (onClick)="guardarSolicitud()">
        </p-button>
    </ng-template>

</p-card>
<shared-loader *ngIf="_showLoader"></shared-loader>